/**
 * Shared Highcharts defaults for owner analytics charts.
 * Import once (e.g. from AnalyticsPage) so credits are disabled for all charts.
 * Mobile: responsive rules improve legend touch targets and spacing.
 */
import Highcharts from 'highcharts';
import AccessibilityModule from 'highcharts/modules/accessibility';

if (typeof AccessibilityModule === 'function') {
  AccessibilityModule(Highcharts);
}

Highcharts.setOptions({
  credits: { enabled: false },
  responsive: {
    rules: [{
      condition: { maxWidth: 768 },
      chartOptions: {
        legend: {
          itemStyle: { fontSize: '13px' },
          itemDistance: 20,
          symbolHeight: 14,
          symbolWidth: 14,
          itemMarginBottom: 8,
        },
        chart: { spacingBottom: 12 },
      },
    }],
  },
});
